import { EnrolmentNoCommissionReason, EnrolmentNotEnrolledReason } from '@studyportals/sp-lord-business-interface';

export class ReviewReason {
	public readonly name: string;
	public readonly type: EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason;

	public constructor(name: string, type: EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason) {
		this.name = name;
		this.type = type;
	}

	public equals(that: ReviewReason | null | undefined): boolean {
		return that ? that.type === this.type : false;
	}
}
